import { Content } from "antd/lib/layout/layout";
import React from "react";
import { Statistic, Row, Col } from "antd";
import {
  LikeOutlined,
 
} from "@ant-design/icons";

const Dashboard = () => {

  return (
    <Content>
      <div style={{ padding: "24px", minHeight: "100vh" }}>
        <Row gutter={8}>
          <Col span={6}>
            <Statistic title="Active Users" value={12} />
          </Col>
          <Col span={6}>
            <Statistic title="Total Order" value={12} />
          </Col>
          <Col span={6}>
            <Statistic
              title="Total Feedback"
              value={12}
              prefix={<LikeOutlined />}
            />
          </Col>
          <Col span={6}>
            <Statistic title="Total Visitor" value={12} />
          </Col>
        </Row>
        <br />
      </div>
    </Content>
  );
};

export default Dashboard;
